module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG1004-21872d879620e3a8128dce16de2f57d2.png";